import React from 'react'
import { Collapse } from 'antd'
import { useTranslation } from 'react-i18next'
import { SimpleNotes } from 'src/components/common/other/SimpleNotes'
// import format from 'date-fns/format'
const { Panel } = Collapse

export function Comments ({ notes, title, isHtmlComment = true }) {
  const { t } = useTranslation()
  if (!notes || !notes.length) return null
  const filterNotes = notes.filter(item => !!item.comment) // do ban dau bat nhap ghi chu, de default ''
  if (filterNotes.length) {
    return (
      <div className='comment'>
        <Collapse className='bg bg-white' expandIconPosition='right' ghost defaultActiveKey={[1]}>
          <Panel
            header={
              <strong className='text-link'>
                {title || t('page.class.text.notes')}
              </strong>
            }
            key={1}
          >
            <SimpleNotes notes={filterNotes} isHtmlComment={isHtmlComment} />
          </Panel>
        </Collapse>
      </div>

    )
  }
  return null
}
